let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("EfE3i")).then(() => parcelRequire('8O7Z4'));